export default __webpack_public_path__ + "static/media/java.59087755.png";